import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const TableCellWithTooltip = ({ value, id }) => {
  if (!value) {
    return <td>{value}</td>;
  }

  const tooltipId = `tooltip-${id}`;

  const renderTooltip = () => (
    <Tooltip id={tooltipId}>{value}</Tooltip>
  );

  return (
    <OverlayTrigger
      placement="top"
      overlay={renderTooltip()}
    >
      <td>+</td>
    </OverlayTrigger>
  );
};

export default TableCellWithTooltip;
